import React from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import CategoryMenu from './CategoryMenu';
import { Loading } from '@aperza/ui';
import { AppService, AppConfigService } from '@aperza/util';
const QUERY = gql `
  query CategoryMenuLoaderQuery($langCode: String, $sellerFlag: Boolean) {
    productCategories(langCode: $langCode, sellerFlag: $sellerFlag) {
      displayCategoryId
      level
      name
      itemCount
      children {
        displayCategoryId
        level
        name
        itemCount
      }
    }
  }
`;
const CategoryMenuLoader = (props) => {
    let appConfig = AppService.appConfig();
    let locale = appConfig.langCode;
    let disableMarketplaceBanner = props.disableMarketplaceBanner;
    let sellerFlag = false;
    if (AppConfigService.shouldShowMarketplaceTopBanner() || !disableMarketplaceBanner) {
        sellerFlag = true;
    }
    let { loading, error, data, refetch, fetchMore } = useQuery(QUERY, {
        variables: {
            langCode: locale,
            sellerFlag,
        },
    });
    if (loading) {
        return (React.createElement("div", { id: "categoryMenu" },
            React.createElement(Loading, null)));
    }
    if (error) {
        return React.createElement("div", null, error.message);
    }
    return React.createElement(CategoryMenu, { productCategories: data.productCategories, ...props });
};
export default CategoryMenuLoader;
export { CategoryMenuLoader };
